import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Container, Card, CardContent, Button } from "@kmf/ui";
import { newsApi, type News, parseDraftContent } from "@/lib/api";

export function NewsDetailPage() {
  const { id } = useParams<{ id: string }>();
  const [news, setNews] = useState<News | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    document.title = "뉴스 - KMF 할랄위원회";
    if (id) {
      loadNews(id);
    }
  }, [id]);

  const loadNews = async (newsId: string) => {
    try {
      const data = await newsApi.find(newsId);

      const firstNews = data[0];
      if (firstNews) {
        setNews(firstNews);
        document.title = `${firstNews.Title} - KMF 할랄위원회`;
      } else {
        setError("뉴스를 찾을 수 없습니다.");
      }
    } catch (err) {
      console.error("Failed to load news:", err);
      setError("뉴스를 불러오는데 실패했습니다.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="public-page py-12 md:py-16">
        <Container>
          <div className="text-center text-muted-foreground">로딩 중...</div>
        </Container>
      </div>
    );
  }

  if (error || !news) {
    return (
      <div className="public-page py-12 md:py-16">
        <Container>
          <Card className="public-panel">
            <CardContent className="py-12 text-center">
              <p className="text-muted-foreground">{error || "뉴스를 찾을 수 없습니다."}</p>
              <Button asChild className="mt-4">
                <Link to="/news">목록으로 돌아가기</Link>
              </Button>
            </CardContent>
          </Card>
        </Container>
      </div>
    );
  }

  const htmlContent = parseDraftContent(news.Content);

  return (
    <div className="public-page py-12 md:py-16">
      <Container>
        <Card className="public-panel">
          <CardContent className="p-6 md:p-8">
            {/* Header */}
            <div className="border-b pb-6">
              <span className="inline-block rounded bg-secondary/10 px-2 py-0.5 text-xs font-medium text-secondary-foreground">
                언론기사
              </span>
              <h1 className="mt-3 text-2xl font-bold text-foreground md:text-3xl">
                {news.Title}
              </h1>
              <p className="mt-2 text-sm text-muted-foreground">
                작성일: {news.UpdateDateTime}
              </p>
            </div>

            {/* Content */}
            <div
              className="article-content prose prose-slate mt-6 max-w-none"
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />

            {/* Back Button */}
            <div className="mt-8 border-t pt-6">
              <Button asChild variant="outline">
                <Link to="/news">목록으로</Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </Container>
    </div>
  );
}
